/**
 * Job Types API
 *
 * API client functions for fetching job type/category options.
 *
 * Endpoint : GET /jobs/job-categories
 * Method   : GET
 * Backend  : apps/backend/src/domains/works-lite/jobs/job-categories/routes.ts
 */

import { apiClient } from '@/lib/api';
import type { JobCategory, JobCategoryPrefillText } from '@skewb-works/contracts';

// Re-export the shared types so consumers don't need to import from contracts directly
export type { JobCategory, JobCategoryPrefillText };

/**
 * Fetch job type/category options for the work orders filter dropdown.
 *
 * @param withCode - When true, only returns categories that have a code value (code IS NOT NULL).
 */
export async function getJobCategories(withCode?: boolean): Promise<JobCategory[]> {
  const url = withCode ? '/jobs/job-categories?withCode=true' : '/jobs/job-categories';
  return apiClient.get<JobCategory[]>(url);
}

/**
 * Fetch all job category prefill text entries.
 */
export async function getJobCategoryPrefillTexts(): Promise<JobCategoryPrefillText[]> {
  return apiClient.get<JobCategoryPrefillText[]>('/jobs/job-category-prefill-text');
}
